import { Card } from "@/components/ui/card";
import { cn } from "@/lib/utils";
import { ReactNode } from "react";

interface MbCardProps {
  children: ReactNode;
  className?: string;
  elevated?: boolean;
}

export function MbCard({ children, className, elevated = false }: MbCardProps) {
  return (
    <Card
      className={cn(
        "overflow-hidden border-2",
        elevated ? "[box-shadow:var(--shadow-lifted)]" : "[box-shadow:var(--shadow-card)]",
        className
      )}
    >
      {children}
    </Card>
  );
}
